import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.is-extensible";
import React, { createContext, useContext } from "react";
var GatsbyMDXScopeContext = createContext({});
export var useMDXScope = function useMDXScope(scope) {
  var contextScope = useContext(GatsbyMDXScopeContext);
  return scope || contextScope;
};

if (typeof useMDXScope !== 'undefined' && useMDXScope && useMDXScope === Object(useMDXScope) && Object.isExtensible(useMDXScope) && !useMDXScope.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useMDXScope, '__filemeta', {
    configurable: true,
    value: {
      name: "useMDXScope",
      filename: "node_modules/gatsby-plugin-mdx/context.js"
    }
  });
}

export var MDXScopeProvider = function MDXScopeProvider(_ref) {
  var __mdxScope = _ref.__mdxScope,
      children = _ref.children;
  return React.createElement(GatsbyMDXScopeContext.Provider, {
    value: __mdxScope
  }, children);
};

if (typeof MDXScopeProvider !== 'undefined' && MDXScopeProvider && MDXScopeProvider === Object(MDXScopeProvider) && Object.isExtensible(MDXScopeProvider) && !MDXScopeProvider.hasOwnProperty('__filemeta')) {
  Object.defineProperty(MDXScopeProvider, '__filemeta', {
    configurable: true,
    value: {
      name: "MDXScopeProvider",
      filename: "node_modules/gatsby-plugin-mdx/context.js"
    }
  });
}